import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch } from "react-redux";
import Notification from "../../utilities/Notification/Notification";
import { Severity } from "../../utilities/Notification/NotificationContent";

import {
  Checkbox,
  Input,
  InputLabel,
  ListItemText,
  TextField,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { AddRoleDialogWrapper } from "./AddRoleDialogStyled";
import { Controller, useForm } from "react-hook-form";
import { Constants } from "../Content";
import {
  addNewRoleDetails,
  getAllUsersAllRoles,
} from "../../../Actions/UserAction";
import { Congiguration } from "../../../Constants/AppConstants";
import ConfirmationBox from "../../ManageData/Popups/ConfirmationBox";

const AddRoleDialog = ({
  show,
  isEdit,
  title,
  handleConfirmClick,
  handleCancelClick,
  editData,
}) => {
  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const dispatch = useDispatch();
  const [allUsersList, setAllUsersList] = useState();
  const [allRolesList, setAllRolesList] = useState([]);
  const [showalretdialog, setShowalretdialog] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [saveButtonDisable, setSaveButtonDisable] = useState(false);

  const [form, setForm] = useState();
  const [roleId, setRoleId] = useState(null);
  React.useEffect(() => {
    const privileges = editData?.privileges?.map((item) => {
      return item?.userActionMasterId;
    });

    setRoleId(isEdit ? editData?.roleId : null);
    setValue("isActive", isEdit ? editData?.isActive : "Active");
    setValue("roleName", isEdit ? editData?.roleName : "");
    setValue("roleDescription", isEdit ? editData?.roleDescription : "");
    setValue("previleage", isEdit ? privileges : []);
  }, [
    editData?.roleName,
    editData?.roleDescription,
    editData?.isActive,
    isEdit,
    setValue,
  ]);
  const handleAlertConfirm = () => {
    setShowalretdialog(false);
    addNewRoleDetails(form)
      .then((res) => {
        handleConfirmClick();
        getUsersandRoles();
      })
      .catch((err) => {
        setNotificationMessage(Constants.GENERALMESSAGE);
        setNotificationSeverity(Severity.ERROR);
        setShowNotification(true);
        setSaveButtonDisable(false);
      });
  };
  const handleAlertCancel = () => {
    setSaveButtonDisable(false);
    setShowalretdialog(false);
  };
  const onSubmit = (data) => {
    if (saveButtonDisable) return;

    const roles = allRolesList.map((roles) => roles?.roleName);
    if (isEdit) {
      if (
        editData?.roleName !== data?.roleName &&
        roles.includes(data?.roleName)
      ) {
        setError(
          "roleName",
          { type: "custom", message: Constants.ROLEEXISTS },
          { shouldFocus: true }
        );
        return;
      }
    } else if (roles.includes(data?.roleName)) {
      setError(
        "roleName",
        { type: "custom", message: Constants.ROLEEXISTS },
        { shouldFocus: true }
      );
      return;
    }
    setForm({
      ...data,
      roleName: data?.roleName.trim(),
      roleDescription: data?.roleDescription.trim(),
      previleage: data?.previleage.join(","),
      isActive: data?.isActive === "Active",
      companyId: Congiguration.CompanyId,
      roleId: roleId,
      // userId:1
    });
    setSaveButtonDisable(true);
    if (isEdit) {
      setShowalretdialog(true);
      return;
    }
    addNewRoleDetails({
      ...data,
      previleage: data?.previleage.join(","),
      isActive: data?.isActive === "Active",
      companyId: Congiguration.CompanyId,
      roleId: roleId,
    })
      .then((res) => {
        handleConfirmClick();
        getUsersandRoles();
      })
      .catch((err) => {
        setSaveButtonDisable(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getUsersandRoles();
  }, []);

  const getUsersandRoles = () => {
    dispatch(getAllUsersAllRoles()).then((data) => {
      data.usersAndRoles.forEach((el) => {
        el.isActive = el.isActive ? "Active" : "Inactive";
      });
      data.rolesAndActions.forEach((el) => {
        el.isActive = el.isActive ? "Active" : "Inactive";
      });
      setAllUsersList(data.usersAndRoles);
      setAllRolesList(removeDuplicatesAction(data.rolesAndActions));
      const sortedRoles = sortRolesByPrivileges(data.rolesAndActions);
    });
  };
  const sortRolesByPrivileges = (rolesAndActions) => {
    const rolesWithPrivileges = {};
    rolesAndActions.forEach((role) => {
      const roleId = role.roleId;
      if (!rolesWithPrivileges[roleId]) {
        rolesWithPrivileges[roleId] = {
          roleId: roleId,
          roleName: role.roleName,
          isActive: role.isActive,
          privileges: [],
        };
      }
      rolesWithPrivileges[roleId].privileges.push({
        userActionMasterId: role.userActionMasterId,
        actionName: role?.actionName,
      });
    });

    return Object.values(rolesWithPrivileges);
  };

  function removeDuplicatesAction(array) {
    const uniqueActions = new Set();
    return array.filter((item) => {
      if (!uniqueActions.has(item?.actionName)) {
        uniqueActions.add(item?.actionName);
        return true;
      }
      return false;
    });
  }
  const handleKeyPress = (e) => {
    if (e.key === " ") {
      e.preventDefault(); // Prevent entering the space character
    }
  };
  return (
    <div>
      <AddRoleDialogWrapper
        open={show}
        onClose={handleCancelClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="paper"
        maxWidth="md"
        fullWidth={true}
      >
        <DialogTitle id="alert-dialog-title" className="customDialogTitle">
          {isEdit ? Constants.EDITROLE : title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className="customDialog"
          >
            <div>
              <div className="inputformside">
                <div className="inputform">
                  <div className="field">
                    <label>
                      <strong>{Constants.ROLEFIELD}</strong>
                      <span className="red"> *</span>
                    </label>
                    <Controller
                      name="roleName"
                      control={control}
                      rules={{
                        required: Constants.ROLEISREQUIRED,
                        maxLength: {
                          value: 50,
                          message: Constants.MAXLENGTH,
                        },
                        validate: (value) =>
                          value.trim().length > 0 || Constants.ROLEISREQUIRED,
                      }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          onBlur={(e) => {
                            setValue("roleName", e?.target?.value?.trim());
                          }}
                          className="formValue"
                          placeholder="Type here"
                          size="small"
                          defaultValue={isEdit ? editData?.roleName : ""}
                          error={!!errors.roleName}
                          helperText={
                            errors.roleName && errors.roleName.message
                          }
                        />
                      )}
                    />
                  </div>
                  <div className="field">
                    <label>
                      <strong>{Constants.STATUS}</strong>
                      <span className="red"> *</span>
                    </label>
                    {isEdit ? (
                      <FormControl className="customDropdown">
                        <Controller
                          name="isActive"
                          control={control}
                          defaultValue=""
                          rules={{ required: Constants.STATUSISREQUIRED }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              error={!!errors.isActive}
                              displayEmpty
                              size="small"
                              helperText={
                                errors.isActive && errors.isActive.message
                              }
                            >
                              <MenuItem value={"Active"}>Active</MenuItem>
                              {isEdit && (
                                <MenuItem value={"Inactive"}>Inactive</MenuItem>
                              )}
                            </Select>
                          )}
                        />
                      </FormControl>
                    ) : (
                      <Controller
                        name="isActive"
                        control={control}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            disabled={true}
                            className="formValue textfieldbg"
                            size="small"
                          />
                        )}
                      />
                    )}
                    {errors.isActive && (
                      <p className="error">{errors?.isActive?.message}</p>
                    )}
                  </div>
                  <div className="field">
                    <label>
                      <strong>{Constants.PRIVILEGE}</strong>
                      <span className="red"> *</span>
                    </label>
                    <FormControl className="customDropdown">
                      <Controller
                        name="previleage"
                        control={control}
                        defaultValue={[]}
                        rules={{ required: Constants.PRIVILEGESISREQUIRED }}
                        render={({ field }) => (
                          <>
                            <Select
                              {...field}
                              select
                              size="small"
                              id="demo-multiple-checkbox"
                              multiple
                              InputLabelProps={{ shrink: true }}
                              input={!(field.value.length > 0) ? null : ""}
                              renderValue={(selected) => {
                                const s = selected?.map((item) => ({
                                  ...allRolesList.filter(
                                    (role) => role?.userActionMasterId === item
                                  ),
                                }));
                                return s
                                  .map((item) => item[0]?.actionName)
                                  .join(",");
                              }}
                              error={!!errors.previleage}
                            >
                              <MenuItem divider dense disabled value="">
                                Select Privilege
                              </MenuItem>
                              {allRolesList
                                .sort((a, b) =>
                                  a.actionName.localeCompare(b.actionName)
                                )
                                .map((option) => (
                                  <MenuItem
                                    divider
                                    key={option?.userActionMasterId}
                                    value={option?.userActionMasterId}
                                  >
                                    <ListItemText
                                      primary={option?.actionName}
                                    />
                                    <Checkbox
                                      sx={{ p: 0 }}
                                      checked={
                                        field?.value?.indexOf(
                                          option?.userActionMasterId
                                        ) > -1
                                      }
                                    />
                                  </MenuItem>
                                ))}
                            </Select>
                          </>
                        )}
                      />
                    </FormControl>
                    {errors.previleage && (
                      <p className="error">{errors?.previleage?.message}</p>
                    )}
                  </div>
                </div>
                <div className="inputform">
                  <div className="field">
                    <label>
                      <strong>Role Description</strong>
                      <span className="red"> *</span>
                    </label>
                    <Controller
                      name="roleDescription"
                      control={control}
                      rules={{
                        required: Constants.ROLEDESCRIPTIONREQUIRED,
                        maxLength: {
                          value: 100,
                          message:
                            "Role Description must not exceed 100 characters",
                        },
                        validate: (value) =>
                          value.trim().length > 0 ||
                          Constants.ROLEDESCRIPTIONREQUIRED,
                      }}
                      render={({ field }) => (
                        <TextField

                          {...field}
                          onBlur={(e) => {
                            setValue("roleDescription", e?.target?.value?.trim());
                          }}
                          className="formValue"
                          placeholder="Type here"
                          size="small"
                          multiline
                          rows={9}
                          defaultValue={isEdit ? editData?.roleDescription : ""}
                          error={!!errors.roleDescription}
                          helperText={
                            errors.roleDescription &&
                            errors.roleDescription.message
                          }
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialogbutton">
          <Button
            variant="outlined"
            className="rightButton"
            onClick={handleCancelClick}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="confirmButton"
            color="success"
            type="submit"
            disabled={saveButtonDisable}
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </DialogActions>
        {showNotification && (
          <Notification
            open={showNotification}
            message={notificationMessage}
            severity={notificationSeverity}
          />
        )}
        {showalretdialog && (
          <ConfirmationBox
            show={showalretdialog}
            handleCancelClick={handleAlertCancel}
            handleConfirmClick={handleAlertConfirm}
            title={Constants.CONFIRM}
            message={Constants.SAVEROLE}
          />
        )}
      </AddRoleDialogWrapper>
    </div>
  );
};

export default AddRoleDialog;
